import { get } from 'generic/api/apiGenerator';
import handleComplete from 'generic/utils/apiUtils';

const fetchMoreLikeThis = ({ ...rest }) => get({ path: '/elastic/more-like-this-id', ...rest }).then(handleComplete);

export {
  // eslint-disable-next-line import/prefer-default-export
  fetchMoreLikeThis,
};
